/* Cuenta atras del carrito.
   Sustituye a Essential Countdown Timer.

   El plazo se guarda en localStorage, asi que sobrevive a recargas y a los
   re-renderizados que hace Dawn al actualizar el carrito. Solo arranca cuando
   hay algo en el carrito y se reinicia cuando el carrito se vacia.

   Modos (data-accion):
     vaciar  - al llegar a cero se vacia el carrito de verdad
     avisar  - al llegar a cero avisa de que la reserva termino
     neutro  - solo informa, no promete caducidad
*/

const CLAVE = 'ccuenta:fin';

class CartCuentaAtras extends HTMLElement {
  constructor() {
    super();
    this.reloj = this.querySelector('[data-reloj]');
    this.minutos = parseInt(this.dataset.minutos, 10) || 10;
    this.accion = this.dataset.accion || 'neutro';
    this.intervalo = null;
    this.expirado = false;
  }

  connectedCallback() {
    this.arrancar();
  }

  disconnectedCallback() {
    this.parar();
  }

  get fin() {
    const guardado = parseInt(localStorage.getItem(CLAVE), 10);
    if (guardado && guardado > Date.now()) return guardado;
    return null;
  }

  arrancar() {
    let fin = this.fin;
    if (!fin) {
      fin = Date.now() + this.minutos * 60 * 1000;
      try {
        localStorage.setItem(CLAVE, String(fin));
      } catch (e) {
        /* modo privado: el contador funciona igual, solo no persiste */
      }
    }
    this.pintar(fin);
    this.parar();
    this.intervalo = setInterval(() => this.pintar(fin), 1000);
  }

  parar() {
    if (this.intervalo) {
      clearInterval(this.intervalo);
      this.intervalo = null;
    }
  }

  pintar(fin) {
    const restante = Math.max(0, fin - Date.now());
    const totalSeg = Math.floor(restante / 1000);
    const min = Math.floor(totalSeg / 60);
    const seg = totalSeg % 60;

    if (this.reloj) {
      this.reloj.textContent = `${String(min).padStart(2, '0')}:${String(seg).padStart(2, '0')}`;
      this.reloj.setAttribute('datetime', `PT${min}M${seg}S`);
    }

    this.classList.toggle('is-urgente', totalSeg > 0 && totalSeg <= 60);

    if (restante <= 0 && !this.expirado) {
      this.expirado = true;
      this.parar();
      this.alExpirar();
    }
  }

  alExpirar() {
    localStorage.removeItem(CLAVE);

    if (this.accion === 'vaciar') {
      fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(() => window.location.reload())
        .catch(() => window.location.reload());
      return;
    }

    if (this.accion === 'avisar') {
      const texto = this.querySelector('.ccuenta__texto');
      if (texto) texto.textContent = 'La reserva de tu carrito ha terminado';
      return;
    }

    this.hidden = true;
  }
}

if (!customElements.get('cart-cuenta-atras')) {
  customElements.define('cart-cuenta-atras', CartCuentaAtras);
}

/* Si al cargar no hay contador es que el carrito esta vacio: olvidamos el
   plazo para que la proxima compra empiece de cero y no herede un tiempo
   ya agotado. */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('cart-cuenta-atras')) {
    localStorage.removeItem(CLAVE);
  }
});
